import React, { useRef } from "react";
import { ProgramItems } from "types/landing";
import PriceImage3 from "assets/images/pricing-imag3.svg";

import "./styles.scss";
import Flickity from "react-flickity-component";
import ArrowRight from "assets/icons/payments/arrowRight.svg";
import ArrowLeft from "assets/icons/payments/arrowLeft.svg";
import { useDisableOrderButton } from "hooks/useDisableOrderButton";

interface Props {
  data?: ProgramItems[];
  onBuy?: (val: ProgramItems) => void;
  initialIndex?: number;
}

export const CarouselPriceMobile = ({ data, initialIndex, onBuy }: Props) => {
  const refCarousel = useRef<any>(null);
  // to prevent double click on button where user place order
  const { isOrderButtonDisable, onBuyOrder } = useDisableOrderButton({ onBuy });
  return (
    <div className="pricing-list-mobile">
      <div
        className="carousel-arrow-wrapper carousel-arrow-wrapper-right"
        onClick={() => {
          refCarousel.current?.next();
        }}>
        <div className="carousel-arrow-container">
          <img src={ArrowRight} />
        </div>
      </div>
      <div
        className="carousel-arrow-wrapper carousel-arrow-wrapper-left"
        onClick={() => {
          refCarousel.current?.previous();
        }}>
        <div className="carousel-arrow-container">
          <img src={ArrowLeft} />
        </div>
      </div>

      <Flickity
        flickityRef={(c) => (refCarousel.current = c)}
        className={"carousel-payment"}
        elementType={"div"}
        options={{
          wrapAround: true,
          initialIndex: initialIndex || 2
        }}
        disableImagesLoaded={false}
        reloadOnUpdate
        static>
        {data?.map((val) => (
          <div
            key={val.id}
            style={{ paddingRight: 20, width: window.screen.width - 80 }}
            className="single-price-item single-price-item">
            <div className="single-bg-wrapper single-bg-wrapper1">
              <div className="price-content-wrapper">
                <div className="price-box-top-content">
                  <h3>{val?.title}</h3>
                  {val?.discount && <h4>{val?.discount}</h4>}
                </div>
                <strong style={{ marginTop: 0 }}>{val?.price}</strong>
                <div className="price-detail">
                  <h3>ש"ח לחודש</h3>

                  <button
                    className="join-btn"
                    onClick={() => onBuyOrder(val)}
                    disabled={isOrderButtonDisable}>
                    הצטרפו עכשיו
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Flickity>
      <span className="heart-price-mobile">
        <img src={PriceImage3} alt="" />
      </span>
    </div>
  );
};
